import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { DataCenterProcess } from "../data-center-process.model";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-data-center-process-form",
  templateUrl: "./data-center-process-form.component.html",
  styleUrls: ["./data-center-process-form.component.scss"],
})
export class DataCenterProcessFormComponent extends BaseFormComponent<DataCenterProcess> {
  erroremessage: string;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookup: LookupService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "DataCenterProcess";
    this.label = this.translate("ClientApp.GNR.DataCenterProcess.TransferBetweenBranches");
    super.ngOnInit();
  }
  setdefault() {
    if (this.model.TransferKindCode > 3) this.erroremessage = this.translate("ClientApp.GNR.DataCenterProcess.CannotEdited");
    else {
      this.lookup
        .getLookupbyCategory("GNR", "TransferKind")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.selectorService.setDataList(
            "TransferKindId",
            x.filter((x) => x.Code < 4)
          );
        });
    }
    this.setFormGroup(this.model);
  }

  addControl() {
    this.cd.markForCheck();
  }
}
